<template>
	<v-expansion-panels
		hover
		multiple
	>
		<v-expansion-panel>
			<v-expansion-panel-header 
				class="text-h6"
				ripple
			>
				<div>	
					<v-icon>mdi-information-outline</v-icon>
					<span class="mx-4">ダンシング☆おにぎり(Dancing☆Onigiri)とは？</span>
				</div>
			</v-expansion-panel-header>
			<v-expansion-panel-content>	
				<p>←[左キー] ↓[下キー] ↑[上キー] →[右キー] おにぎり[ spaceキー ] ([ ]内はデフォルトのキー)</p>
				<p>でリズムに合わせてキーを打つゲームです。</p>
				<p>詳しい遊び方は
					<NewTabLink
						:linkURL="'https://github.com/cwtickle/danoniplus/wiki'"
						:text="'こちら'">
					</NewTabLink>
					をご覧ください（ティックルさんのダンおにGitHubのページに飛びます）
				</p>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<v-expansion-panel>
			<v-expansion-panel-header 
				class="text-h6"
				ripple
			>
				<div>
					<v-icon>mdi-star</v-icon>
					<span class="mx-4">当サイトの難易度について</span>
				</div>
			</v-expansion-panel-header>
			<v-expansion-panel-content>

				<div class="difficulty-explanation">
					<p>
						<label>難易度表記：</label>
						<label class="bigger-level-star">★</label>
						<label>=</label>
						<label>★&times;10</label>
					</p>
				</div>
				<div class="difficulty-explanation">
					<p><span>難易度が</span><span class="key-7">緑文字</span><span>の作品は7key作品です。</span>それ以外は5key作品です。</p>
				</div>
				<div class="difficulty-explanation">
					<table>
						<!-- <caption>難易度名について</caption> -->
						<tr>
							<th>難易度名</th>
							<th>どれくらい？</th>
							<th>難易度(目安)</th>
						</tr>
						<tr>
							<td>Easy</td>
							<td>音ゲー初心者向け</td>
							<td>★1~5</td>
						</tr>
						<tr>
							<td>Normal</td>
							<td>おにぎりや同時押しとかある程度できる人向け</td>
							<td>★6~10</td>
						</tr>
						<tr>
							<td>Hard</td>
							<td>16分乱打とか同時複合にチャレンジする人向け</td>
							<td>★11~20</td>
						</tr>
						<tr>
							<td>Legend</td>
							<td>ヤバい</td>
							<td>★21~</td>
						</tr>
					</table>
				</div>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
	
</template>

<script>
	import NewTabLink from "../NewTabLink.vue";

	export default {
		components: {
			NewTabLink: NewTabLink,
		}
	}
</script>

<style scoped>
	.key-7 {
		color: #3cb371;
	}
	.bigger-level-star {
		color: #F44336;
	}
	table, td, th {
		border-collapse: collapse;
		border: 1px #757575 solid;
	}
</style>